import { Button, Grid, TableContainer, TablePagination } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useAppContext } from "AppContext";
import { SearchNormal1 } from "iconsax-react";
import { useState } from "react";
import { LuTable2 } from "react-icons/lu";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { CustomLoader, EmptyData } from "./DatagridUtils";
import GKTextField from "./GKTextField";
import { Show } from "./Show";

const GKClientDataGrid = (props) => {
  const {
    rows,
    headerComponent,
    showSearch = true,
    loading,
    ref,
    columnsButton = true,
    exportCsv,
    maxHeight,
    showHeaderGrid = true,
    pagination = true,
    pinnedColumns,
    handleSortChange,
    onRowClick,
    initialPageSize,
    rightPinnes,
    minHeight,
    columns,
    headerTitle,
    name,
    emptyButtons,
  } = props;

  const {
    state: { columnsPersist },
    apiRef,
  } = useAppContext();

  const [searchText, setSearchText] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const CustomToolbar = (pgProps) => {
    const { value, onInputChange } = pgProps;
    return (
      <Show.When isTrue={showHeaderGrid}>
        <Grid
          minHeight={"52px"}
          container
          justifyContent={"space-between"}
          p={1}
          alignItems={"center"}
          ref={ref}
          // borderBottom={`solid 1px ${theme.palette.grey[300]}`}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 10,
              width: "100%",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <Show.When isTrue={headerTitle}>{headerTitle}</Show.When>
              <Show.When isTrue={showSearch}>
                <GKTextField
                  style={{ width: 200 }}
                  placeholder={"Search..."}
                  value={value}
                  sx={{
                    "& .MuiInputBase-root ": {
                      height: "35px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E3E8EF",
                    },
                  }}
                  onChange={onInputChange}
                  type="search"
                  autoFocus={isFocused}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  InputProps={{
                    startAdornment: (
                      <SearchNormal1
                        size={26}
                        // color={theme.palette.grey[500]}
                      />
                    ),
                  }}
                />
              </Show.When>
              <Show.When isTrue={exportCsv}>
                {exportCsv && exportCsv()}
              </Show.When>
              <Show.When isTrue={columnsButton}>
                <Button
                  style={{
                    padding: "6px 10px",
                    color: "#697586",
                    border: "1px solid #E3E8EF",
                  }}
                  startIcon={<LuTable2 size={16} />}
                >
                  Columns
                </Button>
              </Show.When>
            </span>
            <Show.When isTrue={headerComponent}>{headerComponent}</Show.When>
          </div>
        </Grid>
      </Show.When>
    );
  };

  const Pagination = (props) => {
    const apiRef = useGridApiContext();

    const handlePageChange = (event, newPage) => {
      apiRef?.current?.setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
      const newRowsPerPage = parseInt(event.target.value, 10);
      apiRef?.current?.setPageSize(newRowsPerPage);
    };

    return pagination ? (
      <TablePagination
        {...props}
        component="div"
        labelRowsPerPage="Rows"
        count={apiRef?.current.getRowsCount()}
        page={apiRef?.current.state.pagination.paginationModel.page}
        rowsPerPage={apiRef?.current.state.pagination.paginationModel.pageSize}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={initialPageSize ? [] : [25, 50, 100]}
      />
    ) : (
      <div> </div>
    );
  };

  const filteredRows =
    rows?.length !== 0 &&
    rows?.filter((row) => {
      return Object.values(row).some((value) => {
        return String(value)
          .toLowerCase()
          ?.includes(searchText.toLowerCase()?.trim());
      });
    });

  const handleRowsReturn = () => {
    if (searchText) {
      return filteredRows;
    }
    if (loading) {
      return [];
    }
    return rows || [];
  };

  return (
    <>
      <TableContainer>
        <DataGridPro
          {...props}
          apiRef={apiRef}
          onSortModelChange={handleSortChange}
          pagination={pagination}
          rows={handleRowsReturn()}
          columnVisibilityModel={
            columnsPersist && name && (columnsPersist[name] || {})
          }
          columns={columns?.map((dataItem) => {
            return {
              ...dataItem,
              disableColumnMenu: true,
              disableExport: true,
            };
          })}
          slots={{
            toolbar: CustomToolbar,
            noRowsOverlay: () => <EmptyData emptyButtons={emptyButtons} />,
            loadingOverlay: CustomLoader,
            detailPanelExpandIcon: () => <MdExpandMore size={20} />,
            detailPanelCollapseIcon: () => <MdExpandLess size={20} />,
            footer: Pagination,
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: initialPageSize || 25,
              },
            },
          }}
          getDetailPanelHeight={() => "auto"}
          slotProps={{
            toolbar: {
              value: searchText,
              onInputChange: (event) => setSearchText(event.target.value),
            },
          }}
          pinnedColumns={{
            ...pinnedColumns,
            right: rightPinnes || ["action"],
          }}
          sx={{
            "& .MuiDataGrid-virtualScroller": {
              maxHeight: maxHeight || "calc(100vh - 256px)",
              minHeight: minHeight || "",
            },
            "&.MuiDataGrid-root .MuiTablePagination-root": {
              // borderTop: `1px solid ${theme.palette.primary.main}44`,
              padding: "0 8px",
            },

            "& .MuiDataGrid-row": {
              "&:hover": {
                cursor: onRowClick ? "pointer" : "",
              },
            },
          }}
        />
      </TableContainer>

      {/* <Show.When isTrue={tableColumnModalOpen}>
        <TableColumnModal
          open={tableColumnModalOpen}
          setOpen={setTableColumnModalOpen}
          columns={columns}
          columnVisibilityModel={columnsPersist}
          dispatch={dispatch}
          name={name}
        />
      </Show.When> */}
    </>
  );
};

export default GKClientDataGrid;
